import { safeInvitationRedirect } from "./privateInvitation.js";

export const EXPIRED_AUTH_LINK_MESSAGE = "That link has expired. Request a sign-in code.";

export const hasExpiredAuthLink = (search = "", hash = "") =>
  new URLSearchParams(search).get("auth_error") === "otp_expired" ||
  new URLSearchParams(hash.replace(/^#/, "")).get("error_code") === "otp_expired";

export const forwardAuthLinkError = (authUrl, location) => {
  if (!hasExpiredAuthLink(location.search, location.hash)) return authUrl;
  const params = new URLSearchParams({
    auth_error: "otp_expired",
    returnUrl: safeInvitationRedirect(`${location.pathname || "/"}${location.search || ""}`),
  });
  return `${authUrl}?${params}`;
};
